var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$moduleConfiguration[_vm.module].orderForm,{tag:"component",attrs:{"module":_vm.module,"order-id":_vm.orderId}})
}
var staticRenderFns = []

export { render, staticRenderFns }